import { render, staticRenderFns } from "./selectedRequisiteInfo.vue?vue&type=template&id=56bb53c4&scoped=true"
import script from "./selectedRequisiteInfo.vue?vue&type=script&lang=ts"
export * from "./selectedRequisiteInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb53c4",
  null
  
)

export default component.exports